
<template>
  <div>
    <div class="max-w-7xl mx-auto border-b">
      <ul
        class="flex mx-auto justify-center relative"
        style="bottom: -1px;"
      >
        <li
          v-for="(tab, index) in tabList"
          :key="index"
          class="tab cursor-pointer border py-2 px-6"
          :class="{active: index === (activeTab - 1)}">
          <label :for="`${index}`" v-text="tab" class="cursor-pointer"/>
          <input
            :id="`${index}`"
            type="radio"
            :name="`${index}-tab`"
            :value="index + 1"
            v-model="activeTab"
            class="hidden"
          />
        </li>
      </ul>
    </div>
    <template v-for="(tab, index) in tabList">
      <div :key="index" v-if="index + 1 === activeTab">
        <slot :name="`tabPanel-${index + 1}`" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 1,
    };
  },
};
</script>

<style scoped>
.tab {
  background-color: #F2F2F2;
  color: #6C6C6C;
}

.tab:hover {
  background-color: #d9d6d3
}

.active {
  background: white;
  color: black;
  border-bottom: none;
}

.active:hover {
  background: white;
}
</style>
